"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAttributes = void 0;
const client_library_1 = require("@seneca/client-library");
const user_service_consts_1 = require("@seneca/user-service-consts");
const gender_1 = __importDefault(require("./gender"));
function validateAttributes(attributes) {
    Object.keys(attributes).map(key => {
        if ([undefined].includes(attributes[key])) {
            throw new client_library_1.InvalidParamError(key, 'not undefined', attributes[key]);
        }
    });
    if (attributes.gender &&
        ![
            gender_1.default.MALE,
            gender_1.default.FEMALE,
            gender_1.default.NON_BINARY,
            gender_1.default.PREFER_NOT_TO_SAY
        ].includes(attributes.gender)) {
        throw new client_library_1.InvalidParamError('gender', attributes.gender, `${gender_1.default.MALE}|${gender_1.default.FEMALE}|${gender_1.default.NON_BINARY}|${gender_1.default.PREFER_NOT_TO_SAY}`);
    }
    if (attributes.type &&
        ![user_service_consts_1.UserType.student, user_service_consts_1.UserType.teacher, user_service_consts_1.UserType.parent].includes(attributes.type)) {
        throw new client_library_1.InvalidParamError('UserType', attributes.type, `${user_service_consts_1.UserType.student}|${user_service_consts_1.UserType.teacher}|${user_service_consts_1.UserType.parent}`);
    }
    if (attributes.learningDifficulties !== undefined &&
        typeof attributes.learningDifficulties !== 'boolean') {
        throw new client_library_1.InvalidParamError('learningDifficulties', attributes.learningDifficulties, `true|false`);
    }
}
exports.validateAttributes = validateAttributes;
//# sourceMappingURL=validations.js.map